exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inquiry-form[data-v-f724d380]{padding:16px 4px 0}.contentFooter[data-v-f724d380]{padding-top:8px}.contentFooter[data-loading=true][data-v-f724d380]{opacity:.25}.contentBody[data-v-f724d380]{position:relative}.contentBody[data-loading=true][data-v-f724d380]{opacity:.25}.loading[data-v-f724d380]{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.subHeadline[data-v-f724d380]{font-weight:700;font-size:13px;line-height:14px}.description[data-v-f724d380]{font-size:11px;line-height:1.4;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f724d380","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/InquiryForm.vue
// module id = k2bg
// module chunks = 0